export default __webpack_public_path__ + "static/media/archi_view2_c.f0fd78c6.webp";